var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { convertToRegularObject } from "../methods";
var IndexedDB = /** @class */ (function () {
    function IndexedDB(config, objectStoreName) {
        this.config = config;
        this.objectStoreName = objectStoreName;
        this.db = null;
    }
    IndexedDB.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = indexedDB.open(_this.config.dbName, _this.config.version);
                        request.onupgradeneeded = function (event) {
                            var db = event.target.result;
                            _this.config.objectStores.forEach(function (objectStoreConfig) {
                                var objectStore = db.createObjectStore(objectStoreConfig.name, {
                                    keyPath: objectStoreConfig.keyPath,
                                    autoIncrement: objectStoreConfig.autoIncrement,
                                });
                                objectStoreConfig.indexes.forEach(function (indexConfig) {
                                    objectStore.createIndex(indexConfig.name, indexConfig.keyPath, {
                                        unique: indexConfig.unique,
                                    });
                                });
                            });
                        };
                        request.onsuccess = function (event) {
                            _this.db = event.target.result;
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.dropDb = function (dbName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = indexedDB.deleteDatabase(dbName);
                        request.onsuccess = function () {
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                        request.onblocked = function () {
                            reject(new Error("Database deletion is blocked."));
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.db) {
                    this.db.close();
                    this.db = null;
                }
                return [2 /*return*/];
            });
        });
    };
    IndexedDB.prototype.addObject = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.add(convertToRegularObject(data));
                        request.onsuccess = function () {
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.addObjects = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        data.forEach(function (item) {
                            var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.add(convertToRegularObject(item));
                            request.onsuccess = function () {
                                resolve();
                            };
                            request.onerror = function (event) {
                                reject(event.target.error);
                            };
                        });
                    })];
            });
        });
    };
    IndexedDB.prototype.getObjectById = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readonly");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.get(key);
                        request.onsuccess = function (event) {
                            resolve(event.target.result);
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.getObjectsByIndex = function (indexName, indexValue) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readonly");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var index = objectStore === null || objectStore === void 0 ? void 0 : objectStore.index(indexName);
                        var request = index === null || index === void 0 ? void 0 : index.get(indexValue);
                        request.onsuccess = function (event) {
                            resolve(event.target.result);
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.getObjectsByRange = function (indexName, lowerBound, upperBound) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readonly");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var index = objectStore === null || objectStore === void 0 ? void 0 : objectStore.index(indexName);
                        var request = index === null || index === void 0 ? void 0 : index.openCursor(IDBKeyRange.bound(lowerBound, upperBound));
                        var results = [];
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                results.push(cursor.value);
                                cursor.continue();
                            }
                            else {
                                resolve(results);
                            }
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.getAllObjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readonly");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.getAll();
                        request.onsuccess = function (event) {
                            resolve(event.target.result);
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.updateObject = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.put(convertToRegularObject(data), key);
                        request.onsuccess = function () {
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.updateObjectByIndex = function (indexName, indexValue, data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var index = objectStore === null || objectStore === void 0 ? void 0 : objectStore.index(indexName);
                        var request = index === null || index === void 0 ? void 0 : index.openCursor(IDBKeyRange.only(indexValue));
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                cursor.update(convertToRegularObject(data));
                                resolve();
                            }
                            else {
                                reject(new Error("Object not found"));
                            }
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.deleteObjectById = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.delete(key);
                        request.onsuccess = function () {
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.deleteObjectsById = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        keys.forEach(function (key) {
                            var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.delete(key);
                            request.onsuccess = function () {
                                resolve();
                            };
                            request.onerror = function (event) {
                                reject(event.target.error);
                            };
                        });
                    })];
            });
        });
    };
    IndexedDB.prototype.deleteObjectByIndex = function (indexName, indexValue) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var index = objectStore === null || objectStore === void 0 ? void 0 : objectStore.index(indexName);
                        var request = index === null || index === void 0 ? void 0 : index.openCursor(IDBKeyRange.only(indexValue));
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                cursor.delete();
                                cursor.continue();
                            }
                            else {
                                resolve();
                            }
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.deleteObjectsByRange = function (indexName, lowerBound, upperBound) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var index = objectStore === null || objectStore === void 0 ? void 0 : objectStore.index(indexName);
                        var request = index === null || index === void 0 ? void 0 : index.openCursor(IDBKeyRange.bound(lowerBound, upperBound));
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                cursor.delete();
                                cursor.continue();
                            }
                            else {
                                resolve();
                            }
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    IndexedDB.prototype.deleteAllObjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        var transaction = (_a = _this.db) === null || _a === void 0 ? void 0 : _a.transaction([_this.objectStoreName], "readwrite");
                        var objectStore = transaction === null || transaction === void 0 ? void 0 : transaction.objectStore(_this.objectStoreName);
                        var request = objectStore === null || objectStore === void 0 ? void 0 : objectStore.clear();
                        request.onsuccess = function () {
                            resolve();
                        };
                        request.onerror = function (event) {
                            reject(event.target.error);
                        };
                    })];
            });
        });
    };
    return IndexedDB;
}());
export default IndexedDB;
